import './avatar.scss';

import Avatar from './Avatar';

export default Avatar;
